import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f55f6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column items-center" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center gender_text q-pb-md q-pt-xs" }, "Mujer", -1))
const _hoisted_4 = { class: "column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center gender_text q-pb-md q-pt-xs" }, "Hombre", -1))

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SexPicker',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const sex = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_btn_toggle, {
      modelValue: _unref(sex),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sex) ? (sex).value = $event : null)),
      color: "white",
      "text-color": "darkD",
      "toggle-color": "accent",
      rounded: "",
      "toggle-text-color": "white",
      unelevated: "",
      options: [
        { value: 'mujer', slot: 'mujer' },
        { value: 'hombre', slot: 'hombre' },
      ]
    }, {
      mujer: _withCtx(() => [
        _createVNode(_component_q_tooltip, null, {
          default: _withCtx(() => [
            _createTextVNode("Mujer")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_icon, {
            name: "fa-solid fa-person-dress",
            class: "col-12 gender_icon q-pt-md q-px-md"
          }),
          _hoisted_3
        ])
      ]),
      hombre: _withCtx(() => [
        _createVNode(_component_q_tooltip, null, {
          default: _withCtx(() => [
            _createTextVNode("Hombre")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_icon, {
            name: "fa-solid fa-person",
            class: "col-12 gender_icon q-pt-md q-px-md"
          }),
          _hoisted_5
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("p", {
      class: "text-weight-bold text-center q-mt-md text-primary underline-link",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (sex.value = 'prefiero-no-responder'))
    }, " Prefiero no responder ")
  ]))
}
}

})